import axios, { AxiosResponse } from 'axios';
import { HttpClient, HttpRequest, HttpResponse } from 'data/protocols/http';
import { getEnv } from 'shared/get-env';

axios.defaults.baseURL = getEnv('REACT_APP_API_URL');

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';

export class AxiosHttpClient implements HttpClient {
  async request(data: HttpRequest): Promise<HttpResponse> {
    let axiosResponse: AxiosResponse;

    if (
      data.headers?.withCredentials === undefined ||
      data.headers?.withCredentials === true
    ) {
      axios.defaults.withCredentials = true;
    } else if (data.headers?.withCredentials === false) {
      axios.defaults.withCredentials = false;
    }

    try {
      axiosResponse = await axios.request({
        url: data.url,
        method: data.method,
        data: data.body,
        headers: data.headers,
        responseType: data.responseType,
      });
    } catch (error: any) {
      axiosResponse = error.response;

      if (data.responseType === 'arraybuffer') {
        const decoder = new TextDecoder();
        const response = JSON.parse(decoder.decode(axiosResponse.data));
        return {
          statusCode: axiosResponse.status,
          body: response,
        };
      }
    }

    return {
      statusCode: axiosResponse.status,
      body: axiosResponse.data,
    };
  }
}
